import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getAdminUser,
  getAllConsultation,
  getDrAvailabilityAction,
  getDrSlotAvailabilityAction,
} from '../store/Actions/AppointmentAction';
import { ActionCreatePatient } from '../store/Actions/PatientAction';
import moment from 'moment';

export const useAppointmentForm = () => {
  const dispatch = useDispatch();
  const { AdminUser, AllConsultation, DrSlotAvailability, DrAvailability } = useSelector(
    state => state?.Appointment
  );
  const [userType, setUserType] = useState('new');
  const [step, setStep] = useState(1);

  const url = new URL(window.location.href);
  const searchParams = url.searchParams;
  const userId = searchParams.get('userId');
  const stepvalue = searchParams.get('step');

  useEffect(() => {
    if (stepvalue === '2') {
      dispatch(getAdminUser({ Query: 'Doctor' }));
      dispatch(getAllConsultation({ Query: '' }));
    }
  }, [stepvalue, dispatch]);

  const disabledDate = current => {
    const today = moment();
    const endDate = moment().add(30, 'days');
    if (current && (current < today || current > endDate)) {
      return true;
    }
    return DrAvailability?.[0]?.disabledDates.includes(current.format('YYYY-MM-DD'));
  };

  const handleCreatePatient = (values, { setErrors, setSubmitting }) => {
    dispatch(
      ActionCreatePatient(
        {
          Query: '',
          obj: values,
        },
        Res => {
          if (Res?.statusCode === 400) {
            setErrors(Res?.data?.errors);
          } else if (Res?.status === 200) {
            // Ideally use navigate here, but for now keeping window.location to match existing behavior or return data to component to handle navigation
            window.location.replace(
              `/add-appoinment?page=1&step=${2}&userId=${Res?.data?.customer.data?.[0]?.id}`
            );
          }
          setSubmitting(false);
        }
      )
    );
  };

  const fetchDoctorAvailability = (drId, consultationType) => {
    if (drId) {
      dispatch(
        getDrAvailabilityAction({
          Query: `?doctor=${drId}&consultationType=${consultationType}`,
          obj: null,
        })
      );
    }
  };

  const fetchSlotAvailability = (drId, consultationType, date, consultationFor) => {
    if (drId && consultationType && date && consultationFor) {
      dispatch(
        getDrSlotAvailabilityAction({
          Query: ``,
          obj: {
            doctor: drId,
            consultationType: consultationType,
            bookingDate: date,
            consultationFor: consultationFor,
          },
        })
      );
    }
  };

  return {
    userType,
    setUserType,
    step,
    setStep,
    stepvalue,
    userId,
    AdminUser,
    AllConsultation,
    DrSlotAvailability,
    DrAvailability,
    disabledDate,
    handleCreatePatient,
    fetchDoctorAvailability,
    fetchSlotAvailability,
  };
};
